import { getRates } from '../actions'
import { subscriptionsSelector } from '../selectors'
import { RateCurrency } from 'shared/price-utilities'
import '../styles/tickets.scss'

const TicketCard = props => {
    const { rateId, rateName, currencySymbol, shortDescription, amount, grsId } = props

    return (
        <li>
            <div className="card text-center">
                <div className="card-header">
                    <h3>
                        <T>car.park.tickets.subscription</T>
                    </h3>
                    <hr />
                    <h2>{rateName}</h2>
                </div>

                <div className="card-block">
                    <span className="price-tag">
                        <RateCurrency value={amount} currency={currencySymbol} />
                    </span>

                    <p>{shortDescription}</p>
                </div>

                <div className="card-footer">
                    <Link
                        className="btn btn-outline-primary"
                        to={{ pathname: `/booking/${grsId}/subscriptions`, search: { rateId } }}>
                        <T>car.park.tickets.subscribe</T>
                    </Link>
                </div>
            </div>
        </li>
    )
}

class Tickets extends Component {
    componentDidMount() {
        const { grsId, getRates } = this.props

        getRates(grsId)
    }

    render() {
        const { rates, grsId } = this.props

        if (rates.length === 0) return null

        return (
            <div className="container tickets">
                <div className="header col text-center clearfix">
                    <h2>
                        <T>car.park.tickets.title</T>
                    </h2>
                </div>
                <ul className="tickets-list">
                    {rates.map((rate, index) => (
                        <TicketCard {...rate} grsId={grsId} key={index} />
                    ))}
                </ul>
            </div>
        )
    }
}

const mapStateToProps = createStructuredSelector({
    rates: subscriptionsSelector,
})

const actions = { getRates }

export default connect(mapStateToProps, actions)(Tickets)
